import {
  AutocompleteArrayInput,
  ReferenceArrayInput,
  required,
  SimpleForm,
  TextInput,
} from "react-admin";
import { Grid } from "@mui/material";
import { administrationRequests } from "api/administrationApi";

const SpecialityGroupForm = () => {
  return (
    <SimpleForm>
      <Grid container>
        <Grid
          item
          xs={12}
        >
          <TextInput
            label="Описание"
            source="description"
            validate={[required()]}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceArrayInput
            source="specialityIds"
            reference={administrationRequests.getSpecialitiesSelect()}
            filter={{ NotInGroup: true }}
          >
            <AutocompleteArrayInput
              label="Специалност"
              validate={[required()]}
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            />
          </ReferenceArrayInput>
        </Grid>
      </Grid>
    </SimpleForm>
  );
};
export default SpecialityGroupForm;
